import React, { useEffect, useState } from 'react';
import { useLanguage } from '../../../context/language';
import Loading from '../../../assets/loading.gif';
import 'jquery-ui-dist/jquery-ui';
import { callPaykuPaymentApi, getDeposit } from '../../../api/fastcoinService';
import { getURLBackToPanel } from '../../../context/brokersUrl';
import 'jquery-ui-dist/jquery-ui';
const without_iframe = []


const PaykuPayment = (props) => {

    const { translate, lang } = useLanguage();
    const [loadingPaykuPaymentInfo, setLoadingPaykuPaymentInfo] = useState(false);
    const [infoPakuPayment, setInfoPakuPayment] = useState(sessionStorage.getItem("paykupayment_info") !== null ? JSON.parse(sessionStorage.getItem("paykupayment_info")) : {});
    const [waitingPayment, setWaitingPayment] = useState(sessionStorage.getItem("waiting_payment") !== null ? JSON.parse(sessionStorage.getItem("waiting_payment")) : false);
    const [isError, setIsError] = useState(false)
    const [erorMsg, setErrorMsg] = useState("")

    useEffect(() => {
        translate();
    }, [translate]);



    const callProntoPaga = () => {
        setLoadingPaykuPaymentInfo(true);
        setIsError(false)
        if (infoPakuPayment[props.payment_type] === undefined) {
            callPaykuPaymentApi(sessionStorage.getItem("order_no"), props.payment_type)
                .then(res => {
                    if (res !== undefined) {
                        setInfoPakuPayment({ ...infoPakuPayment, [props.payment_type]: res });
                        sessionStorage.setItem("paykupayment_info", JSON.stringify({ ...infoPakuPayment, [props.payment_type]: res }));
                        setLoadingPaykuPaymentInfo(false)
                        // Open checkout link in new tab after getting it from API
                        if (res.url) {
                            window.open(res.url, '_blank');
                        }
                    } else {
                        setErrorMsg("Please, talk with the Administrator.");
                        setLoadingPaykuPaymentInfo(false);
                        setIsError(true)
                    }
                })
                .catch(err => {
                    console.log(err.toString());
                    setErrorMsg(err.response?.data?.message ? err.response?.data?.message : "Internal server error")
                    setIsError(true)
                }).finally(() => {
                    setLoadingPaykuPaymentInfo(false);
                    translate();
                });
        } else {
            // If payment info already exists in session, open it in new tab
            if (infoPakuPayment[props.payment_type]?.url) {
                window.open(infoPakuPayment[props.payment_type].url, '_blank');
            }
            setLoadingPaykuPaymentInfo(false);
        }

    }

    useEffect(() => {
        let timeout;
        function checkPayment() {
            timeout = setTimeout(function () {
                getDeposit(sessionStorage.getItem("order_no"))
                    .then(res => {
                        if (res.status.toLowerCase() === "paid") {
                            setWaitingPayment(false);
                            sessionStorage.setItem("waiting_payment", false);
                            window.location.replace(getURLBackToPanel());
                        } else {
                            checkPayment();
                        }
                    })
                    .catch(err => {
                        alert(err);
                        checkPayment();
                    })
            }, 30000);
        }
        if (waitingPayment) {
            sessionStorage.setItem("waiting_payment", true);
            checkPayment();
        }
        return () => clearTimeout(timeout);
    }, [loadingPaykuPaymentInfo]);


    useEffect(() => {
        if (infoPakuPayment[props.payment_type] === undefined && props?.payment_type !== 'payphone_payment') {
            callProntoPaga()
        } else if (infoPakuPayment[props.payment_type]?.url && props?.payment_type !== 'payphone_payment') {
            // If payment info already exists in session storage, open it in new tab
            window.open(infoPakuPayment[props.payment_type].url, '_blank');
        }
    }, [])

    useEffect(() => {
        const handleMessage = (event) => {
            if (event.data && event.data.type === 'redirected') {
                const redirectedUrl = event.data.url;
                window.location.href = redirectedUrl
            }
        }
        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);


    const callApi = (e) => {
        e.preventDefault();
        callProntoPaga()
    }

    return (
        <>
            {loadingPaykuPaymentInfo && <div className="group-pix-content">
                <div className="pix-container">
                    <div className="grup-crypto-opt">
                        <div className="msg-pix">
                            <img src={Loading} alt={"loading"} width="30px" height="30px" />
                        </div>
                    </div>
                </div>
            </div>}

            <div className=''>
                {infoPakuPayment[props.payment_type] !== undefined ?
                    <>
                        {without_iframe.includes(props.payment_type) ? <div>
                            <p style={{textAlign:"center"}}><strong>{infoPakuPayment[props.payment_type]['html_Instrucctions']}</strong></p>
                        </div> :
                            <div style={{ width: '100%' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
                                    <h3>Checkout opened in new tab</h3>
                                    <p>The payment checkout has been opened in a new tab. Please complete your payment there.</p>
                                    <button 
                                        onClick={() => window.open(infoPakuPayment[props.payment_type]['url'], '_blank')}
                                        style={{
                                            padding: '10px 20px',
                                            backgroundColor: '#007bff',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                            marginTop: '10px'
                                        }}
                                    >
                                        Open Checkout Again
                                    </button>
                                </div>
                            </div>}

                    </>
                    :
                    <></>
                }

                {isError && <div style={{ display: 'flex', flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center' }}>
                    <h4>{erorMsg}</h4>
                </div>}
            </div>

        </>
    )
}

export default PaykuPayment;
